import {
  JobWorkType,
  acceptOnlyFilterdKeys,
  arrangeFiltersByOrder,
  basePathRewrite,
  checkIsFJFeatureAllowed,
  commonPropsForSSR,
  filterDropItems,
  getDrawerPopCount,
  getURLSearchParams,
  getfullUrl,
  handleDrawerScroll,
  handleMouseMoveAway,
  loadHeadScripts,
  loadLoginScript,
  makeApiCalls,
  modifyQueryLocation,
  modifySelectedLocation,
  readCookie,
  sortSubcategories,
  titleValue,
  updateSearchActivity,
} from '@components/common';

import {
  API_NAMES,
  LOCATION_CHECK_BOX_VALUE,
  SAVED_SEARCH_BUTTON_STATE,
  _CONSTANTS,
  allowedSectionsToHide,
  getScrollHeightDrawerExp,
} from '@components/common/constant';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import { jobsCategory } from '@components/common/jobCategoryHelper';
import JobListingContainer from '@components/jobListContainer';
import JobSearchSteps from '@components/jobSearchSteps';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import {
  AccoladesType,
  CategoryLocalization,
  CompaniesHiringCount,
  ICompanies,
  IDeviceType,
  IJob,
  JobsCategories,
  SubCategories,
  SuccessStoriesType,
  SuccessStory,
  cdnEXPTType,
} from '@components/shared.types';
import { getWidgetArr } from '@license-admin/boldfjcomponents';
import { SoftRegModal } from '@license-admin/boldjobs';
import { width } from '@styles/device.styled';
import { fireExperimentEvent } from '@utils/cdnTracking';
import { track } from '@utils/eventTrack';
import { getTotalJobsCount } from '@utils/jobsCount';
import useMediaQuery from '@utils/useMediaQuery';
import {
  getCategorySuccessStories,
  getJobCategories,
  getJobSubcategories,
} from 'API/ApiHelpers';
import {
  getCompaniesHiringCount,
  getFirstJobDetails,
  getJobDetails,
  getLocalizationAndConfig,
  getLocalizationFunction,
  getSavedJobsId,
} from 'API/jobs';
import { isRCPortal } from 'helper';
import { getOrUpdateGUID, isQueryEmpty } from 'helper/eventTrackingUtils';
import {
  getBackendVisiterExpDetail,
  getCDNExptDetails,
  runDrawerExperimentAddListener,
} from 'helper/experiments/experimentActions';
import { RMCPortalExperiments } from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

type ResponseProps = {
  isLoggedIn: boolean;
  categoryDetails?: any;
  localization: CategoryLocalization;
  saveJobIds: Array<string>;
  jobsData: JobsDataType;
  newsData: any;
  headerProps: Array<string>;
  queryParams: { [key: string]: Array<string> | string | undefined };
  successStoriesList: Array<SuccessStoriesType>;
  isPremiumUser: boolean;
  jobSubCategories?: SubCategories;
  faqData?: any;
  categorySuccessStories?: [SuccessStory];
  deviceType: IDeviceType;
  selectedFilters: { [key: string]: Array<string> };
  pageName?: string;
  searchedJobTitle?: string;
  isPopularTitle?: boolean;
  moreJobs?: any;
  breadcrumbDropdown?: any;
  tabsToHide?: string[];
  showAllDropFilters?: boolean;
  companiesHiringCount: CompaniesHiringCount;
  saveSeachButtonState: string;
  signupLocalization: any;
  firstJobDetails: IJob;
  firstJobComDetails: ICompanies;
  cdnExptData?: cdnEXPTType;
};

type JobsDataType = {
  jobFilters: Array<FiltersType>;
  jobs: {
    currentPage: number;
    resultPerPage: number;
    totalCount: number;
    totalPages: number;
    results: Array<JobsType>;
  };
};

type FiltersType = {
  name: string;
  categoryWithCount: CategoryWithCount;
  category?: JobsCategories[];
};

type CategoryWithCount = {
  [key: string]: number;
};

type JobsType = {
  id: string;
  title: string;
  saved: boolean;
  featured: boolean;
  allowedCandidateLocation: Array<string>;
  company: Company;
  description: string;
  jobLocations: Array<any>;
  jobSchedules: Array<string>;
  jobTypes: Array<string>;
  postedDate: string;
  remoteOptions: Array<any>;
};

type Company = {
  accolades: Array<AccoladesType>;
  logo: string;
  name: string;
  slug: string;
};

type FiltersDataByOrderType = {
  name: string;
  categoryWithCount: CategoryWithCount;
  slug: string;
};

const CategoryPage = (props: any) => {
  const {
    jobsData,
    queryParams,
    localization,
    successStoriesList,
    newsData,
    isLoggedIn,
    jobSubCategories,
    faqData,
    deviceType,
    categoryDetails,
    userAgent,
    cdnExptData,
  } = props;
  const mobileView = useMediaQuery(width.tabletSm) || deviceType === 'mobile';
  let jobFilterDataByOrder: Array<FiltersDataByOrderType> =
    arrangeFiltersByOrder(
      jobsData?.jobFilters || [],
      true,
      queryParams,
      props.deviceType
    );

  const [guid, setGuid] = useState<any>(getOrUpdateGUID()); // for event tracking

  let queryParamsByOrder: {
    [key: string]: Array<string> | string | undefined;
  } = arrangeFiltersByOrder(queryParams);

  const widgetsToShow = getWidgetArr(props.isPremiumUser, isLoggedIn);
  const [isSoftRegAlreadyShown, setIsSoftRegAlreadyShown] = useState(
    !!readCookie(_CONSTANTS.SOFT_REG_POPUP_DISPLAYED)
  );
  const [showSoftRegPopUp, setShowSoftRegPopUp] = useState<boolean>(false);

  const [showJobSearchSteps, setShowJobSearchSteps] = useState(false);
  const [shouldShowSearchStepDrawer, setShouldShowSearchStepDrawer] = useState(
    !isLoggedIn
  );

  const handleMouseMove = (e: any) => {
    handleMouseMoveAway(e, setShowSoftRegPopUp, !isSoftRegAlreadyShown);
  };

  const mobilePopUpShowWaitTime = 15000;
  const totalJobCountSoftRegMobile = useRef('');
  const [mobileHeading, setMobileHeading] = useState('');
  const [isAddStaticSearchList, setAddStaticSearchList] =
    useState<boolean>(false);

  useEffect(() => {
    const conductExperiment = async () => {
      const visitorId = readCookie(_CONSTANTS.VSTR);
      if (visitorId) {
        const experimentData = await getBackendVisiterExpDetail(
          deviceType,
          {
            mobile: RMCPortalExperiments.rmcLocationFieldMobile,
            desktop: RMCPortalExperiments.rmcLocationFieldDesktop,
          },
          userAgent
        );
        if (experimentData?.variant && experimentData?.variant > 2) {
          setAddStaticSearchList(true);
        }
      } else {
        setTimeout(conductExperiment, 500);
      }
    };

    const timeoutId = setTimeout(conductExperiment, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    // show mobile pop up after given time //
    // const getMobileheading = ()=>{
    //   props?.signupLocalization[0]?.m_soft_reg_heading?.replace(
    //     '{0}',
    //     parseInt(totalJobCountSoftRegMobile.current) >= 200
    //       ? categoryDetails?.categoryTitle?.replace('Jobs', '') ||
    //           props.searchedJobTitle
    //       : 'remote'
    //   ) || ''
    // }

    const time = setTimeout(async () => {
      if (mobileView && !showSoftRegPopUp && !isSoftRegAlreadyShown) {
        const totalJobCount = jobsData?.jobs?.totalCount || 0;
        totalJobCountSoftRegMobile.current = await getTotalJobsCount(
          totalJobCount
        );
        if (parseInt(totalJobCount) >= 200) {
          const categoryTitle = categoryDetails?.categoryTitle?.replace(
            /Jobs/g,
            ''
          );
          setMobileHeading(
            props?.signupLocalization[0]?.m_soft_reg_heading?.replace(
              /\{0\}/g,
              categoryTitle
            )
          );
        } else {
          setMobileHeading(
            props?.signupLocalization[0]?.m_soft_reg_heading?.replace(
              /\{0\}/g,
              'remote'
            )
          );
        }
        setShowSoftRegPopUp(true);
      }
    }, mobilePopUpShowWaitTime);

    return () => clearTimeout(time);
  }, []);

  useEffect(() => {
    const popCount = getDrawerPopCount();
    const addListeners = () => {
      const vstr = readCookie(_CONSTANTS.VSTR);
      if (vstr) {
        if (shouldShowSearchStepDrawer && popCount < 5) {
          //experiment
          runDrawerExperimentAddListener(
            deviceType,
            userAgent,
            setShowJobSearchSteps,
            setIsSoftRegAlreadyShown,
            true
          );
        }
      } else {
        setTimeout(() => {
          addListeners();
        }, 1000);
      }
      if (popCount >= 4) {
        setTimeout(() => {
          document.addEventListener('mouseleave', handleMouseMove);
        }, 10000);
      }
    };
    addListeners();

    return () => {
      window.removeEventListener('mouseleave', handleMouseMove);
      window.removeEventListener('scroll', () =>
        handleDrawerScroll(600, setShowJobSearchSteps, setIsSoftRegAlreadyShown)
      );
      window.removeEventListener('scroll', () =>
        handleDrawerScroll(
          getScrollHeightDrawerExp(),
          setShowJobSearchSteps,
          setIsSoftRegAlreadyShown
        )
      );
    };
  }, []);

  useEffect(() => {
    // for ecom exp: FJ-2322
    if (!props.isPremium && categoryDetails) {
      const lastCategory = {
        id: categoryDetails.id,
        name: categoryDetails.categoryTitle,
        slug: categoryDetails.slug,
      };
      updateSearchActivity({ lastCategory: lastCategory });
    }
  }, []);

  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({
          categoryName: categoryDetails?.slug || '',
          canonicalTwo: props.useCanonicalTwo,
          isQueryParamsEmpty: props.isQueryParamsEmpty,
        })}
      </Head>
      <Script
        src="/ui-experimentation/cdn/experiment-sync.min.js"
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      {shouldShowSearchStepDrawer && showJobSearchSteps && (
        <JobSearchSteps
          isCloseAllowed={true}
          showJobSearchSteps={showJobSearchSteps}
          setJobSearchStepsState={setShowJobSearchSteps}
          signupAndFind={localization.unlock_banner.signup_and_find}
          mobileView={mobileView}
          categoryDetails={categoryDetails}
          jobsData={jobsData}
          hiringCount={props.companiesHiringCount}
          setShouldShowSearchStepDrawer={setShouldShowSearchStepDrawer}
          screenName="jobs by category"
          isModalDrawerOpen={
            !!shouldShowSearchStepDrawer && !!showJobSearchSteps
          }
          isCategoryPage={true}
        />
      )}

      {!isLoggedIn && showSoftRegPopUp && !isSoftRegAlreadyShown && (
        <SoftRegModal
          config={props.config}
          trackFunction={track}
          basePathRewrite={basePathRewrite}
          loadLoginScript={loadLoginScript}
          loadHeadScripts={loadHeadScripts}
          localization={localization}
          themeType={props.themeType}
          jobDataCount={props.jobsData?.jobs?.totalCount}
          isFromWizardPage={false}
          isCloseAllowed={mobileView}
          hiringCount={props.companiesHiringCount}
          isMobileView={mobileView}
          isExperiment={
            cdnExptData && cdnExptData?.vID == '3' && !props.isPremiumUser
          }
          returnUrl={''}
          isGoogleLogin={true}
          isAppleLogin={true}
        />
      )}
      <JobListingContainer
        isLoggedIn={isLoggedIn}
        isAddStaticSearchList={isAddStaticSearchList}
        selectedCountry={props.selectedCountry}
        location={props.selectedLocation}
        countyList={props.countyList}
        jobsData={jobsData}
        localization={localization}
        newsData={newsData}
        jobFilters={jobFilterDataByOrder}
        queryParamsByOrder={queryParamsByOrder}
        successStoriesList={successStoriesList}
        savedJobsIdsList={props.saveJobIds}
        categoryDetails={categoryDetails}
        widgetsName={widgetsToShow}
        isPremiumUser={props.isPremiumUser}
        jobSubCategories={jobSubCategories}
        faqData={faqData}
        showWorkAnywhereInUsCheckbox={props.showWorkAnywhereInUsCheckbox}
        showWorkAnywhereInWorldCheckbox={props.showWorkAnywhereInWorldCheckbox}
        categorySuccessStories={props.categorySuccessStories}
        mobileView={mobileView}
        selectedFilters={props.selectedFilters}
        pageLocation="acmgm"
        isCategorySubCategory
        deviceType={deviceType}
        searchedJobTitle={props.searchedJobTitle}
        isCategoryJobsPage={props.isCategoryJobsPage}
        pageName={props.pageName}
        sectionsToHide={
          !props.isPopularTitle
            ? [allowedSectionsToHide.WIDGETS]
            : [allowedSectionsToHide.CATEGORY_TABS]
        }
        breadCrumbName={
          !props.isPopularTitle
            ? `${
                props.isPremiumUser
                  ? 'category-rc-premium'
                  : 'category-rc-public'
              }`
            : `${
                props.isPremiumUser ? 'jobs-page-premium' : 'jobs-page-public'
              }`
        }
        breadCrumbNameValue={[titleValue(props?.categoryDetails?.name) || '']}
        moreDropdownText={!props.isPopularTitle ? '' : 'More Jobs'}
        moreJobs={!props.isPopularTitle ? [] : props.moreJobs}
        tabsToHide={props.tabsToHide}
        breadcrumbDropdown={props.breadcrumbDropdown}
        showAllDropFilters={props.showAllDropFilters}
        saveSeachButtonState={props.saveSeachButtonState}
        setGuid={setGuid}
        guid={guid}
        firstJobDetails={props.firstJobDetails}
        firstJobComDetails={props.firstJobComDetails}
        topBanner={{
          showBanner: true,
          bannerTitle: `Remote ${titleValue(
            props?.pageTitle
          )} Jobs - Work From Home`,
        }}
        isCategoryPage={isRCPortal}
        JobWorkType={JobWorkType}
        isDynamicBreadcrumb={true}
        isExperiment={
          cdnExptData && cdnExptData?.vID == '3' && !props.isPremiumUser
        }
      />
    </>
  );
};

export default CategoryPage;

export const getServerSideProps: GetServerSideProps<ResponseProps> = async ({
  query,
  req,
  resolvedUrl,
}: GetServerSidePropsContext) => {
  const fullUrl = getfullUrl(req);
  // ! Last minute change to fix canonical issue for 'remote-jobs/international' page and 'remote-jobs/international' page
  const useCanonicalTwo = resolvedUrl?.includes('useCanonicalTwo');

  const category = query.category as string;
  if (!category) {
    // Check if this will ever be used
    return {
      notFound: true,
    };
  }
  let filterValues = acceptOnlyFilterdKeys(query);
  if (category.toLowerCase() !== category) {
    return {
      redirect: {
        destination: `/remote-jobs/${encodeURI(category.toLowerCase())}`,
        permanent: false,
      },
    };
  }

  /**
   * Steps 1: If category not found in job title list then show 404 page.
   * Steps 2: Check if category is present in category list using API.
   * Steps 3: If category not found check in job title list.
   * Steps 4: If category found select the category first else check in job title list and show in search box.
   */
  let selectedLocation: string = getURLSearchParams(query, 'joblocations');
  let countryName = '';

  let localizationKey: string = 'new_jobs';
  let preSelectedFilters: { [key: string]: Array<string> } = {
    categories: [category as string],
  };

  let commonSSRProps = await commonPropsForSSR(
    req,
    localizationKey,
    preSelectedFilters
  );

  const [countyListServiceRes, newsResponse = {}, successStoriesList = []] =
    await makeApiCalls([
      API_NAMES.COUNTRY_LIST_EB,
      API_NAMES.NEWS_WIDGET,
      API_NAMES.SUCCESS_STORY_WIDGET,
    ]);

  /**
   *  Below code is to modify the lookup service response remove @@@ and null values
   */

  let { locationObj, isInternationalLocation, locationNameAndState }: any =
    modifySelectedLocation(selectedLocation, countyListServiceRes);
  if (selectedLocation) {
    selectedLocation = locationNameAndState;
    countryName = locationObj.countryName;
    query = modifyQueryLocation(locationObj, isInternationalLocation, query);
  }

  query = mapQueryParams(query);
  let queryString: string = getFilterQueryString(query);
  let searchKeyword: string = getURLSearchParams(queryString, 'searchkeyword');

  const jobsCategoryResult = await jobsCategory(
    category,
    commonSSRProps,
    filterValues,
    query,
    queryString
  );

  let categoryDetails = jobsCategoryResult?.categoryDetails || {};
  commonSSRProps = jobsCategoryResult.commonSSRProps;
  queryString = jobsCategoryResult.queryString;
  query = jobsCategoryResult.query;

  if (!categoryDetails.categoryTitle) {
    // if [category] is not category,top search or title then redirect to 404
    return {
      notFound: true,
    };
  }

  // Show success stories only on the first page
  const tabsToHide: string[] = [];
  if (
    typeof query?.page === 'string' &&
    query?.page != '1' &&
    tabsToHide.length < 1
  ) {
    tabsToHide.push('successstories');
  }

  let showWorkAnywhereInUsCheckbox = false;
  let showWorkAnywhereInWorldCheckbox = false;
  if (query?.joblocations) {
    showWorkAnywhereInUsCheckbox = query.joblocations?.includes(
      LOCATION_CHECK_BOX_VALUE.US
    );
    showWorkAnywhereInWorldCheckbox = query.joblocations?.includes(
      LOCATION_CHECK_BOX_VALUE.WORLD
    );
  }

  let saveSeachButtonState = SAVED_SEARCH_BUTTON_STATE.save_search;

  if (query.savedsearch)
    saveSeachButtonState = SAVED_SEARCH_BUTTON_STATE.save_changes;

  const promiseList = [
    getJobDetails(
      `search${queryString.slice(0, -1)}`,
      commonSSRProps.cookieHeader,
      true,
      false,
      req.headers,
      true,
      fullUrl
    ),
    checkIsFJFeatureAllowed()
      ? getJobSubcategories(category, commonSSRProps.cookieHeader)
      : {},
    getLocalizationFunction(category),
    checkIsFJFeatureAllowed()
      ? getCategorySuccessStories(category, commonSSRProps.cookieHeader)
      : {},
    getSavedJobsId(commonSSRProps.isPremiumUser, commonSSRProps.cookieHeader),
    getLocalizationAndConfig('new_jobs'),
    getJobCategories(commonSSRProps.cookieHeader),
  ];
  if (!commonSSRProps.isPremiumUser) {
    promiseList.push(getCompaniesHiringCount());
  }
  const [
    { data },
    jobSubCategories = {},
    faqData,
    categorySuccessStories = {},
    saveJobIds,
    [localization],
    jobsCategories,
    companiesHiringCount,
  ] = await Promise.all<any>(promiseList);
  // Sort the filters drop items
  data.jobFilters = filterDropItems({
    filterData: data?.jobFilters || [],
    categoriesData: jobsCategories.data,
  });
  //remove non required fields
  // data.jobs.results.forEach((job: any) => {
  //   delete job.accolades;
  //   delete job.jobCategories;
  //   delete job.categories;
  //   delete job.jobBenefits;
  //   delete job.description;
  //   delete job.jobSummary;
  // });
  if (categorySuccessStories && categorySuccessStories?.data?.length === 0) {
    tabsToHide.push('successstories');
  }

  if (
    jobSubCategories &&
    Array.isArray(jobSubCategories?.data?.relatedCategory) &&
    jobSubCategories.data.relatedCategory.length > 1
  ) {
    sortSubcategories(jobSubCategories.data.relatedCategory);
  }

  if (
    Array.isArray(jobSubCategories?.data?.subCategory) &&
    jobSubCategories.data.subCategory.length > 1
  ) {
    sortSubcategories(jobSubCategories.data.subCategory);
  }

  const signupLocalization = await getLocalizationAndConfig('signup');
  const firstJobData = await getFirstJobDetails(
    data?.jobs?.results[0],
    commonSSRProps.cookieHeader,
    commonSSRProps.isPremiumUser
  );

  const isQueryParamsEmpty = isQueryEmpty(resolvedUrl);
  return {
    props: {
      ...commonSSRProps,
      companiesHiringCount: companiesHiringCount || {},
      localization,
      jobsData: data,
      selectedCountry: countryName || '',
      newsData: newsResponse?.data || {},
      queryParams: query,
      headerProps: ['/remote-jobs', ''],
      saveJobIds: saveJobIds || [],
      successStoriesList: successStoriesList?.data || [],
      categoryDetails: categoryDetails || {},
      jobSubCategories: jobSubCategories?.data || {},
      faqData: faqData,
      categorySuccessStories: categorySuccessStories?.data || [],
      showWorkAnywhereInUsCheckbox: showWorkAnywhereInUsCheckbox,
      showWorkAnywhereInWorldCheckbox: showWorkAnywhereInWorldCheckbox,
      pageTitle: categoryDetails?.categoryTitle || '',
      selectedLocation: selectedLocation,
      countyList: [],
      searchedJobTitle: searchKeyword || '',
      tabsToHide,
      showAllDropFilters: true,
      url: fullUrl,
      saveSeachButtonState: saveSeachButtonState,
      isCategoryJobsPage: true,
      signupLocalization,
      ...firstJobData,
      fullwidth: true,
      useCanonicalTwo: useCanonicalTwo || false,
      userAgent: req?.headers['user-agent'] ?? '',
      isQueryParamsEmpty: isQueryParamsEmpty,
      cdnExptData: getCDNExptDetails(
        query,
        commonSSRProps.deviceType,
        commonSSRProps?.cookieHeader
      ),
    },
  };
};
